import { useRdPageLockStatus } from '@neo.tax/rd/hooks';
import { RedirectState, useOnboardingFlowStage, useCompanyInformation, useProducts } from '@neo.tax/shared';

export const useRdProjectsRedirect = (): RedirectState => {
  const { loading: loadingCompanyInformation } = useCompanyInformation();
  const { loading: loadingOnboardingFlowStage } = useOnboardingFlowStage();
  const { loading: loadingPageLockStatus } = useRdPageLockStatus();
  const { loading: loadingProducts } = useProducts();

  return {
    isLoading: loadingCompanyInformation || loadingOnboardingFlowStage || loadingPageLockStatus || loadingProducts,
  };
};
